import React from 'react'

import Loading from '../../layout/Loading'
import Grid from '../../layout/Grid'
import NoResults from '../../layout/NoResults'
import { Course } from '../../../../api/courses/types'
import CourseCard from './CourseCard'
import ExternalCourseCard from './ExternalCourseCard'

type Props = { data: Course[] | null | undefined, isLoading: boolean, error: Error | null }
const CoursesGrid: React.FC<Props> = ({ data, isLoading, error }) => {
  if(isLoading) return <Loading size='fill-container' />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults />
  return (
    <Grid>
      {data?.map((course) => (
        course.isExternal ? (
          <ExternalCourseCard
            key={course.title}
            title={course.title}
            category={course.mainCategory.name}
            image={course.thumbnailsUrls.desktop}
            url={course.externalUrl as string}
            duration={course.duration as string}
            price={course.price as number}
            startMonthYear={course.startMonthYear as string}
            description={course.description}
          />
        ) : (
          <CourseCard
            id={course.id}
            key={course.title}
            title={course.title}
            category={course.mainCategory.name}
            documentsAmount={course.documents?.length || 0}
            videosAmount={course.sections?.reduce((acc, section) => acc + (section?.videos?.length ?? 0), 0) || 0}
            totalWatchTime={course.totalWatchTime || 0}
            image={course.thumbnailsUrls.desktop}
            completed={course.userActivity?.completed || false}
            totalPlayTime={course.userActivity?.totalPlayTime}
            difficulty={course.difficultyLevel?.name}
            bookmarked={course.userActivity?.saved}
          />
        )
      ))}
    </Grid>
  )
}

export default CoursesGrid
